import dynamic from 'next/dynamic';
import { Box, BoxProps, Grid, Text } from '@chakra-ui/react';
import { Column, KeySellingPoints as Props } from '@/types';
import Heading from '../Heading';
import IconSelector from '../IconSelector';

const ArrowButton = dynamic(() => import('../ArrowButton'));

const ColumnItem = ({ title, description, icon, button }: Column) => (
  <Grid
    gridRowGap={[4, 5]}
    gridTemplateRows="min-content"
    alignItems="flex-start"
    alignContent="flex-start"
  >
    <Text as="span" fontSize={[null, null, '125%']}>
      <IconSelector type={icon} color="success.500" size="4em" weight="thin" />
    </Text>
    <Heading as="h3" variant="subheading">
      {title}
    </Heading>
    <Text maxWidth="44ch">{description}</Text>
    {button && <ArrowButton {...button} />}
  </Grid>
);

const KeySellingPoints = ({
  title,
  data,
  ...styles
}: Omit<BoxProps, keyof Props> & Props) => (
  <Box borderRadius="lg" background="white" p={[7, null, 10]} {...styles}>
    {title && (
      <Heading variant="h5" mb="4">
        {title}
      </Heading>
    )}
    <Grid
      gridTemplateColumns="repeat(auto-fit, minmax(200px, 1fr))"
      gridColumnGap={[4, 7, 14]}
      gridRowGap="5"
    >
      {data?.map((col) => (
        <ColumnItem {...col} key={col.title} />
      ))}
    </Grid>
  </Box>
);

export default KeySellingPoints;
